import React from 'react'

export default function PointIcon({ color = null }) {
  return (
    <svg
      className="PointIcon"
      height="24"
      viewBox="0 0 17 24"
      width="17"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color }}
    >
      <path
        d="M8.21 0C3.684 0 0 3.683 0 8.21c0 2.258 1.004 4.35 3.068 6.395 2.997 2.975 4.393 5.72 4.393 8.645V24h1.5v-.75c0-2.91 1.38-5.577 4.47-8.643 2.067-2.047 3.07-4.138 3.07-6.396C16.5 3.683 12.816 0 8.21 0"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
}
